<template>
  <nav class="bubly-navbar" :class="{ open: opened }" role="navigation" aria-label="main navigation" @keyup.esc="toggleNav">
    <div class="bubly-navbar-brand">
      <div class="nav-bubly-logo-social-wrapper">
      <router-link class="bubly-navbar-logo" to="/" title="bubly" aria-label="bubly sparkling water logo">
        <CustomIcon :link="Logo" className="logo"></CustomIcon>
      </router-link>
      <div class="nav-social-wrapper hide-on-menu-toggle">
        <ul>
          <li v-for="(item, i) in items" :key="i">
            <a class="network" :href="item.link" target="blank" :aria-label="item.text">
              <VueIcon :name="item.icon"></VueIcon>
            </a>
          </li>
          <li>
            <a class="network" title="Giphy" href="https://giphy.com/bublywater" target="blank" aria-label="Giphy (opens in a new tab)" >
              <custom-icon :link="Giphy"></custom-icon>
            </a>      
          </li>  
      </ul>
      </div>
      </div>
      <div class="nav-links-hamburger-wrapper">
        <a href="#"
            class="menu-links buynow hide-on-menu-toggle"
            data-toggle="modal"
            data-target="#locator-modal"
            v-on:click="destiniNavIframe"
            aria-label="buy now (link opens in popup)"
        >
            buy now
        </a>
        <router-link class="menu-links hide-on-menu-toggle " to="mixology" target="_self">	
          mixology	
        </router-link>	
        <router-view />
        <hamburger :state="opened" @toggle="toggleNav" />
      </div>
    </div>
    <overlay :state="opened" @close="toggleNav"/>
			<div id="locator-modal" class="modal fade in" role="dialog" v-on:click="resetOverflow">
				<div class="modal-body">
					<button type="button" class="close" data-dismiss="modal" v-on:click="resetOverflow" tabindex="0" aria-label="close modal">
					&times;
					</button>
					<div class="destinilocatordiv nav_destini">
					</div>
				</div>
				<button
					type="button"
					class="close close--mobile"
					data-dismiss="modal"
           v-on:click="resetOverflow"
           tabindex="0"
           aria-label="close modal"
					>
					&times;
				</button>
			</div>
  </nav>
</template>
<script>
  import Hamburger from '@/components/navigation/Hamburger';
  import Overlay from '@/components/navigation/Overlay';
  import CustomIcon from '@/components/custom-icons/Icon';
  import Logo from '@/assets/bubly-logo.svg';
  import VueIcon from 'vue-awesome/components/Icon';
  import Giphy from '@/assets/giphy-logo-blue.svg';
  export default {
    name: 'navigation',
    data() {
      return {
      opened: false,    
        Logo,
        items: [{
          icon: 'facebook-square',
          link: 'https://www.facebook.com/bublywater/',
          text: 'Facebook (opens in a new tab)',
        }, {
          icon: 'instagram',
          link: 'https://www.instagram.com/bublywater/',
          text: 'Instagram (opens in a new tab)',
        }, {
          icon: 'twitter-square',
          link: 'https://twitter.com/bublywater',
          text: 'Twitter (opens in a new tab)',
        }, {
          icon: 'youtube-square',
          link: 'https://www.youtube.com/channel/UC7xAT5b3Dgd40KipH7ZFdSQ/featured?disable_polymer=1',
          text: 'YouTube (opens in a new tab)',
        }],
        Giphy
      };
    },
    methods: {
      goHome() {
        if (this.$router) this.$router.push('/');
      },
      toggleNav() {
        this.opened = !this.opened;
        this.hideScroll(this.opened);
        this.hideMenuItems(this.opened);
        const overlay = document.querySelector(".overlay")
        if(!overlay.style.display)
          document.querySelector(".menu_destini").innerHTML = ""
      },
      hideScroll(isOpened) {
        this.$parent.$el.style.overflow = (isOpened) ? "hidden" : "visible";
        // this.$parent.$el.attributes.tabindex = (isOpened) ? "-1" : "";     
        this.$parent.$el.style.height = (isOpened) ? "96vh" : "100%";
      },
      triggerModal: (e) => {
        const container = e.target.getAttribute("data-destini-container");
        const association = e.target.getAttribute("data-destini-association");
        destini.init(container);
        destini.loadWidget(association);
      },
      hideMenuItems(isOpened) {
        const hideElements = document.getElementsByClassName("hide-on-menu-toggle");
        for (var i = 0; i < hideElements.length; i++) {
            hideElements[i].classList.toggle("hide");
         }
      },
      resetOverflow(e) {
        document.querySelector("body").style.overflow = "auto";
        document.querySelector(".nav_destini").innerHTML = "";
        document.querySelector(".menu_destini").innerHTML = "";
        this.resetTabIndex()
      },
      destiniNavIframe(e) { 
        const el = document.createElement("div");
        el.setAttribute("id", "destini_container")
        el.setAttribute("class", "destini-locators-all-products")
        document.querySelector(".nav_destini").appendChild(el)

        loadIframe();
        document.querySelector("body").style.overflow = "hidden"
        document.querySelector("#destini").style.height = "1370px"

        this.deactivateTabIndex()  
      },
      deactivateTabIndex() {
        const tabIndexZeroList = document.querySelectorAll('#app *:not(nav #locator-modal *):not([tabindex="-1"])')
        tabIndexZeroList.forEach((node, i) => {
          node._prevTabindex = node.getAttribute('tabindex');
          node.setAttribute('tabindex', -1); 

        })
      },
      resetTabIndex() {
        const tabIndexZeroList = document.querySelectorAll('#app *:not(nav #locator-modal *)')
        tabIndexZeroList.forEach((node, i) => {
          if (node._prevTabindex) {
              node.setAttribute('tabindex', node._prevTabindex);
              node._prevTabindex = null;
          } else {
            node.removeAttribute('tabindex');
          }
        })
      }
    },
    components: {
      Hamburger,
      Overlay,
      CustomIcon,
      VueIcon,
    },
  };
</script>
<style lang='scss' scoped>
  @import './../variables';
  @import "./static/libs/bootstrap-modified";

  .hide {
	  display:none !important;
  }
  .nav-links-hamburger-wrapper a:hover {
    text-decoration: none;
    color:#009FDE;
  }
  a:link { /* Essentially means a[href], or that the link actually goes somewhere */
    text-decoration: none;
    color:#009FDE;
  }
  a:visited {
    text-decoration: none;
    color:#009FDE;
  }
  a:hover {
    text-decoration: none;
    color:#009FDE;
  }
  a:active {
    text-decoration: none;
    color:#009FDE;
  }
  .bubly-navbar-brand {
    padding: rem(15);
    position: relative;
    z-index: 1000;
    height: 88px;
    box-sizing: border-box;
    float: none;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .bubly-navbar-logo {
    text-align: center;
    display: block;
    cursor: pointer;
    .logo {
      max-height: 3.75rem;
      max-width: 22vw;
      fill: $bubly-blue;
      transition: fill .5s ease-in-out;
      float: left;
      margin-top: 2px;
    }
  }
  .bubly-navbar.open {
    .logo {
      fill: $bubly-white;
    }
  }
  
  //copied from social.vue
  a[title='Giphy'] {
    width: 41px;
    height: 43px;
    margin-top: .3em;
  }
  svg path.st2 {
      fill: $bubly-blue !important;
  }
  .nav-links-hamburger-wrapper {
      display: inline-flex;
      justify-content: center;
      align-items: center;
  }
  
  .menu-links {
     color: $bubly-blue;
     font-size: rem(26);
     margin-right: 3.8rem;
      &:first-child {
        margin: 1.2em;
    }
  }
  .nav-social-wrapper {
    font-size: 2.6875rem;
    display: flex;

    &>ul {
      display: flex;
      list-style-type: none;
      padding: 0; 

       li {
        margin-right: 14px;
       }
    }

  }
  .nav-social-wrapper {
      .network {
        color: $bubly-blue;
      }
  }
  .nav-bubly-logo-social-wrapper {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  
  .social-icons {
    color: $bubly-white;
    font-size: rem(18);
    @include breakpoint('tablet') {
      font-size: rem(29);
    }
  }
  .caption {
    padding: 0 12px;
    font-size: rem(15);
    vertical-align: bottom;
    line-height: 2.3;
    @include breakpoint('tablet') {
      font-size: rem(21);
      padding-right: 0;
      line-height: rem(21);
      margin: 20px 0;
    }
  }
  .network {
    margin: 0 7px;
    padding: 5px;
    display: inline-block;
	  width: 35px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  a[title='Giphy'] {
    display: inline-flex;
    margin-left: 0;
    padding: 0;
    width: 21px;
    height: 19px;
    margin-left: 6px;
    @include breakpoint('tablet') {
      width: 29px;
      height: 30px;
    }
  }
  .large-icons {
    font-size: rem(43);
    position: relative;
    padding-left: 110px;
    display: inline-block;
    .caption {
      font-size: rem(21);
      font-weight: 600;
      text-transform: lowercase;
      position: absolute;
      top: 5px;
      left: 0;
    }
    .network {
      margin: 0 4px;
    }
  }
  .top-caption {
    font-size: rem(43);
    margin-bottom: rem(20);
    .caption {
      display: block;
      text-transform: lowercase;
      font-size: rem(21);
    }
    a[title='Giphy'] {
      width: 41px;
      height: 43px;
    }
  }
  .hide-on-menu-toggle {
    @include breakpoint('mobileonly') {
      display:none;
    }
  }
.modal {
    padding-top: 50px;
}
#locator-modal .modal-body {
    text-align: center;
    width: 100%;
    max-width: 840px;
    min-width: 300px;
    height: auto;
    height: 100vh;
    margin-left: auto;
    margin-right: auto;
    max-height: 750px !important;
    padding: 0px;
}
.modal-open .modal {
    background-color: rgba($color: #000000, $alpha: 0.6);
}
#locator-modal .close {
    position: relative;
    margin-right: -30px;
    color: #fff;
    margin-top: -30px;
    font-size: 40px;
    opacity: 1;
    &--mobile{
        position: absolute;
        margin: 0 auto;
        top: 3px;
        @media (min-width: 768px) {
            display: none;
        }
    }
}
.destinilocatornavdiv {
    background: none;
    width: 100%;
    overflow-y: auto;
}

.destini-locators-all-products{
  height: 770px;
   overflow-y: scroll;
}

iframe#destini {
  height: 1370px !important;
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue